export default __webpack_public_path__ + "static/IBMPlexSans-Regular-Greek-f09fea7bf930fa14a8141a2896422e92.woff";